<template>
    <div class="card-challenge-list-item-incomplete">
        <div class="wr-card-challenge-list-item-incomplete__users">
            <div class="card-challenge-list-item-incomplete__user1">
                <div class="wr-card-challenge-list-item-incomplete__user1">
                    <img
                        :src="userImageLink1"
                        class="card-challenge-list-item-incomplete__user-img" />
                    <span class="card-challenge-list-item-incomplete__username">{{ username1 }}</span>
                    <div
                        class="card-challenge-list-item-incomplete__user-status"
                        :class="userStatusClass1">
                        <span class="card-challenge-list-item-incomplete__user-status-icon"></span>
                        <span class="card-challenge-list-item-incomplete__user-status-text">{{ userStatusText1 }}</span>
                    </div>
                </div>
            </div>
            <div class="card-challenge-list-item-incomplete__user2">
                <div class="wr-card-challenge-list-item-incomplete__user2">
                    <img
                        :src="userImageLink2"
                        class="card-challenge-list-item-incomplete__user-img" />
                    <span class="card-challenge-list-item-incomplete__username">{{ username2 }}</span>
                    <div
                        class="card-challenge-list-item-incomplete__user-status"
                        :class="userStatusClass2">
                        <span class="card-challenge-list-item-incomplete__user-status-icon"></span>
                        <span class="card-challenge-list-item-incomplete__user-status-text">{{ userStatusText2 }}</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="card-challenge-list-item-incomplete__status">
            <span class="card-challenge-list-item-incomplete__status-text">{{ challengeStatusText }}</span>
        </div>
        <div class="card-challenge-list-item-incomplete__separator">
            <span class="card-challenge-list-item-incomplete__separator-icon"></span>
            <span class="card-challenge-list-item-incomplete__separator-text">VS</span>
        </div>
    </div>
</template>

<script>
    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                    Component Imports
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */


    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                    Component Instance
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */
    export default {
        props: {
            challengeItem: {
                type: Object,
                default: {
                    id: 8,
                    status: "ONGOING",
                    user1: {
                        id: 3,
                        username: "kral1790",
                        status: "WAIT-PRACTICE"
                    },
                    user2: {
                        id: 1,
                        username: "temren",
                        status: "WAIT-ANSWER"
                    }
                }
            }
        },

        computed: {
            userImageLink1(){
                // return this.$store.state.api.img + this.challengeItem.user1.id + '.jpg';
                return this.$store.state.api.getImage + this.challengeItem.user1.id;
            },

            userImageLink2(){
                // return this.$store.state.api.img + this.challengeItem.user2.id + '.jpg';
                return this.$store.state.api.getImage + this.challengeItem.user2.id;
            },

            username1(){
                let userSession = this.$store.state.userSession;
                if(userSession.id === this.challengeItem.user1.id){
                    return 'sen';
                }
                return this.challengeItem.user1.username;
            },

            username2(){
                let userSession = this.$store.state.userSession;
                if(userSession.id === this.challengeItem.user2.id){
                    return 'sen';
                }
                return this.challengeItem.user2.username;
            },

            userStatusClass1(){
                if(this.challengeItem.user2.status === 'REJECTED'){
                    return 'card-challenge-list-item-incomplete__cancelled';
                }
                return 'card-challenge-list-item-incomplete__' + this.challengeItem.user1.status.toLowerCase();
            },

            userStatusClass2(){
                return 'card-challenge-list-item-incomplete__' + this.challengeItem.user2.status.toLowerCase();
            },

            userStatusText1(){
                let userSession = this.$store.state.userSession;

                if(this.challengeItem.user2.status === 'REJECTED'){
                    return this.$t(`challenge.status.cancelled`);
                }
                if(userSession.id === this.challengeItem.user1.id && ['LEFT-PRACTICE', 'DONE-PRACTICE'].includes(this.challengeItem.user1.status)){
                    return this.$t(`challenge.status.${this.challengeItem.user1.status.toLowerCase()}`) + 'N';
                }
                return this.$t(`challenge.status.${this.challengeItem.user1.status.toLowerCase()}`);
            },

            userStatusText2(){
                let userSession = this.$store.state.userSession;
                if(userSession.id === this.challengeItem.user2.id && ['REJECTED', 'LEFT-PRACTICE', 'DONE-PRACTICE'].includes(this.challengeItem.user2.status)){
                    return this.$t(`challenge.status.${this.challengeItem.user2.status.toLowerCase()}`) + 'N';
                }
                return this.$t(`challenge.status.${this.challengeItem.user2.status.toLowerCase()}`);
            },

            challengeStatusText(){
                return this.$t(`challenge.generalStatus.${this.challengeItem.status}`);
            }
        }
    };
</script>

<style scoped src="@/css/components/card-challenge-list-item-incomplete.css"></style>